import { apiWithGetHeader } from "./api";
import { BASE_URL } from "./../services/environment";
import { API_STATUS } from "./apiUrl";

export const getApiCall = async (url, payload) => {
  const response = await apiWithGetHeader(BASE_URL, payload)
    .get(url)
    .catch(function (error) {
      return Promise.reject(error.response);
    });

  if (response.data.status === API_STATUS.SUCCESS) {
    return response;
  } else {
    return Promise.reject(response);
  }
};
